// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"000e2a40","732":"05c66d4a","977":"5e25e2d5"}[chunkId] + ".chunk.js";
};